import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroup.UploadUiFile.IRequest;
type Response = Api.Core.DealerGroup.UploadUiFile.IResponse;
type Headers = Api.Core.DealerGroup.UploadUiFile.IHeaders;
const apiDealerGroupUploadUiFilePath = '/api/DealerManagement/DealerGroup/:id/UploadUiFile';
export default async function dealerGroupUploadUiFileApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiDealerGroupUploadUiFilePath, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
